module.exports = "<select [(ngModel)]=\"ngModel\" [name]=\"type\" class=\"field-input list standard w-select\">\n  <option *ngFor=\"let option of options\" [value]=\"option.id\">\n    {{option.name || option.rate}}\n  </option>\n</select>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/stat/stat.component.html
// module id = 1017
// module chunks = 1